import './DropdownButton.css';
import { useUI } from '../../hooks/useUI';
import { resources } from '../../utils/resources';

const DropdownButton = ({id}) => {
    const { toggleDropdown, isDropdownOpen } = useUI();
    const isOpen = isDropdownOpen(id);

    return (
        <button style={{backgroundImage: `url(${resources.icons.arrowDown})`}} onClick={() => toggleDropdown(id)} className={isOpen ? 'dropdownButton active' : 'dropdownButton'}></button>
    )
}

export default DropdownButton;